<!-- Selected Company Chip -->
@if (selectedCompany(); as company) {
<div class="selected-chip">
  <div class="chip-content">
    <lucide-icon name="Building2" size="14" class="text-muted"></lucide-icon>
    <span class="chip-name">{{ company.dbaName || company.legalName }}</span>
    @if (company.dotNumber) {
    <span class="chip-dot">DOT: {{ company.dotNumber }}</span>
    }
    <app-badge [variant]="getSourceBadgeVariant(company.source)" [title]="getSourceLabel(company.source)" size="xs"></app-badge>
  </div>
  @if (!disabled()) {
  <button type="button" class="chip-clear" (click)="clearSelection()">
    <lucide-icon name="X" size="14"></lucide-icon>
  </button>
  }
</div>
} @else {
<!-- Search Input -->
<div class="search-wrapper">
  <lucide-icon name="Search" size="14" class="search-icon"></lucide-icon>
  <input
    type="text"
    class="search-input"
    [placeholder]="placeholder()"
    [value]="searchText()"
    [disabled]="disabled()"
    (input)="onSearchInput($event)"
    (focus)="onFocus()"
    autocomplete="off"
  />
  @if (isLoading()) {
  <div class="search-spinner">
    <lucide-icon name="Loader2" size="14" class="animate-spin"></lucide-icon>
  </div>
  }
</div>

<!-- Dropdown Results -->
@if (isOpen()) {
<div class="dropdown">
  @if (results().length === 0 && !isLoading()) {
  <div class="dropdown-empty">
    <lucide-icon name="SearchX" size="16" class="text-muted"></lucide-icon>
    <app-text size="sm" color="muted">No companies found</app-text>
  </div>
  }

  @for (result of results(); track result.id) {
  <button type="button" class="dropdown-item" (click)="selectCompany(result)">
    <div class="item-main">
      <div class="item-name-row">
        <span class="item-name">{{ result.dbaName || result.legalName }}</span>
        <app-badge [variant]="getSourceBadgeVariant(result.source)" [title]="getSourceLabel(result.source)" size="xs"></app-badge>
      </div>
      @if (result.dbaName && result.dbaName !== result.legalName) {
      <span class="item-dba">{{ result.legalName }}</span>
      }
      <div class="item-meta">
        @if (result.dotNumber) {
        <span>DOT: {{ result.dotNumber }}</span>
        }
        @if (result.mcNumber) {
        <span>MC: {{ result.mcNumber }}</span>
        }
        @if (result.city || result.state) {
        <span>{{ result.city }}{{ result.city && result.state ? ', ' : '' }}{{ result.state }}</span>
        }
      </div>
    </div>
    <div class="item-flags">
      @if (result.isCarrier) {
      <span class="flag-tag">Carrier</span>
      }
      @if (result.isBroker) {
      <span class="flag-tag">Broker</span>
      }
    </div>
  </button>
  }

  <!-- Add Manually Option -->
  <div class="p-2 border-t border-border bg-card/50">
    <button
      type="button"
      class="w-full flex items-center justify-between p-2 rounded-md hover:bg-primary/10 text-primary transition-colors text-sm font-medium"
      (click)="openDotSearchModal()"
    >
      <div class="flex items-center gap-2">
        <lucide-icon name="Search" size="16"></lucide-icon>
        <span>Can't find it? Search DOT Registry</span>
      </div>
      <lucide-icon name="ChevronRight" size="14" class="opacity-50"></lucide-icon>
    </button>
  </div>
</div>
}
}
